export interface SnackbarMessage {
  message: string;
  type: MessageType;
  urlMessage?: string;
  detailsUrl?: string;
}

export interface SnackbarMessageData {
  id: string;
}

export type SnackbarType = SnackbarMessage & SnackbarMessageData;

export interface SnackbarState {
  messages: SnackbarType[];
}

export enum MessageType {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}
